import * as React from "react";
import { useContext } from "react";
import qs from 'qs'
import { Suspense } from "react";
import { Spinner } from "../components";
import { Route } from "react-router-dom";
import { UseLocationFilter } from "../modules/app/layout/UseGlobalFilter";
import { PageFilters, PageFiltersContext } from '../modules/app/layout/PageFilters';
import { AppLocationFilter } from "../modules/app/layout/AppLocationFilter";
import RegisterPortal from '../components/portals/RegisterPortal';
import { ANGULAR_FILTERS } from "../modules/app/navigator/navigatorPortalNames";

const LazyClientDashboardApp = React.lazy(() => import("./ClientDashboardApp"));

const excludePaths = /^\/reviewBuilder\/(?!.*?\/dashboard|.*?\/contacts|.*?\/reviews)|reviewBuilder\/.*?wizard|admin\/v2|user\/account|chatmeterAdmin|manageTool/

/**
 * manages the container for the old angular application
 * - sets the visibility/behavior of the location dropdown according to the url
 * - forces the chrome dome stylepack while mounted
 * - wraps the angular app in the react app navigation
 */
export default function ClientDashboardAppPage() {
  const pageFiltersContext = useContext(PageFiltersContext);
  return <Route render={({location}) => {
    function shouldShowDropdown() {
      return !excludePaths.test(location.pathname);
    }

    function handlesOwnPageFilters() {
      return /\/scores\//.test(location.pathname);
    }

    function shouldNotIncludeAccounts() {
      return location.pathname === "/reviews" &&
        qs.parse(location.search.replace(/^\?/, '')).reportType === 'storeComparison'
    }

    return <React.Fragment>
      {
        shouldShowDropdown() && (handlesOwnPageFilters()
        ? 
        <PageFilters 
          global={<AppLocationFilter shouldNotIncludeAccounts={shouldNotIncludeAccounts()}/>}>
            <RegisterPortal id={ANGULAR_FILTERS}/>
          </PageFilters>
        : 
        pageFiltersContext.isHorizontal 
        ? 
        <UseLocationFilter shouldNotIncludeAccounts={shouldNotIncludeAccounts()} /> 
        : 
        <PageFilters global={<AppLocationFilter shouldNotIncludeAccounts={shouldNotIncludeAccounts()}/>} />)
      }
      <Suspense fallback={<Spinner center/>}>
        <LazyClientDashboardApp/>
      </Suspense>
    </React.Fragment>
  }} />
}
